import { render, staticRenderFns } from "./Wines.vue?vue&type=template&id=8a3301f4&scoped=true&"
import script from "./Wines.vue?vue&type=script&lang=js&"
export * from "./Wines.vue?vue&type=script&lang=js&"
import style0 from "./Wines.vue?vue&type=style&index=0&id=8a3301f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3301f4",
  null
  
)

export default component.exports